import React, { FunctionComponent } from "react";
import Box, { BoxProps } from "../box/Box";

interface TabPanelProps extends BoxProps {
	/** index of this tab. Each tab has it's unique index */
	index: number | string;

	/** index of currently selected tab. If tab's index==selectedTabIndex then tab become visible */
	selectedTabIndex: number | string;
}

const TabPanel: FunctionComponent<TabPanelProps> = (props: TabPanelProps) => {
	const { children, selectedTabIndex, index, ...otherProps } = props;

	return (
		// mark as hidden to avoid the component re-renderer when switch between tabs
		<Box	
			data-csi-automation="TabPanel"
			hidden={selectedTabIndex !== index}
			{...otherProps}
		>
			{children}
		</Box>
	);
};

export default TabPanel;